import { useTranslation } from "react-i18next";
import { FleetBannerSection } from "~/components/FleetBannerSection";
import { HOME_FLEET_BANNER } from "~/data/fleet-banner";
import Hero from "~/components/home/Hero";
import Products from "~/components/home/Products";
import UseCases from "~/components/home/UseCases";
import DataPrivacy from "~/components/home/DataPrivacy";
import Reviews from "~/components/home/Reviews";
import LastChance from "~/components/home/LastChance";
import Footer from "~/components/home/Footer";
import { getProductReviews } from "~/lib/reviews.server";
import { getAppRatings, getProductRatings, toStoreRatings } from "~/lib/madisongwapi.server";
import { REVIEWS_PRODUCT_ID } from "~/lib/reviews";
import type { Route } from "./+types/home";

// Reviews and store ratings are fetched server-side so this social proof is in the
// initial HTML. None of these fetches throw, so an outage only hides that data.
export async function loader() {
  const [reviews, productRatings, appRatings] = await Promise.all([
    getProductReviews({ productId: REVIEWS_PRODUCT_ID }),
    getProductRatings(),
    getAppRatings(),
  ]);
  return { reviews, storeRatings: toStoreRatings(productRatings, appRatings) };
}

export default function Home({ loaderData }: Route.ComponentProps) {
  const { t } = useTranslation("home");
  return (
    <>
      <head>
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
      </head>
      <Hero />
      <Products />
      {/* Products' own trailing padding (40px mobile, 24px desktop) already covers part of the
          gap to the banner; pt-0/lg:pt-[36px] make up the rest so the total is 40px mobile / 60px
          desktop, per Figma. Bottom padding (24px mobile, 60px desktop) carried over unchanged. */}
      <FleetBannerSection content={HOME_FLEET_BANNER} namespace="home" className="pt-0 pb-6 lg:pt-[36px] lg:pb-15" />
      <UseCases />
      <Reviews reviews={loaderData.reviews} storeRatings={loaderData.storeRatings} />
      <DataPrivacy />
      <LastChance />
      <Footer />
    </>
  );
}
